// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"161":"edaa97c4e562a1618dc1","986":"449592036134aa40e717"}[chunkId] + ".js";
};